// extracted by mini-css-extract-plugin
export default {"card":"f7-z"};